<template>
  <v-menu offset-y :close-on-content-click="false" @update:model-value="onToggle">
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" icon variant="text" class="mr-1" aria-label="Notificaciones">
        <v-badge :model-value="unreadCount > 0" :content="unreadCount" color="error" max="99">
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card min-width="360" max-width="420">
      <v-card-title class="d-flex justify-space-between align-center text-subtitle-1 pa-3">
        Notificaciones
        <v-btn v-if="unreadCount > 0" size="x-small" variant="text" @click="marcarTodas">
          Marcar todas leídas
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-list density="compact" max-height="400" class="overflow-y-auto">
        <v-list-item v-if="items.length === 0" class="text-center text-medium-emphasis py-6">
          Sin notificaciones
        </v-list-item>
        <v-list-item
          v-for="n in items"
          :key="n.id"
          :class="{ 'bg-grey-lighten-4': !n.leida }"
          @click="abrir(n)"
        >
          <template #prepend>
            <v-icon :color="colorNivel(n.nivel)">{{ iconoNivel(n.nivel) }}</v-icon>
          </template>
          <v-list-item-title class="text-body-2 font-weight-medium">{{ n.titulo }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{ n.mensaje }}</v-list-item-subtitle>
          <div class="text-caption text-medium-emphasis mt-1">{{ formatFecha(n.fechaCreacion) }}</div>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'NotificacionesBell',
  setup () {
    const store = useStore()
    const router = useRouter()
    let intervalId = null

    const items = computed(() => store.getters['notificaciones/items'])
    const unreadCount = computed(() => store.getters['notificaciones/unreadCount'])

    function onToggle (abierto) {
      if (abierto) store.dispatch('notificaciones/fetch')
    }

    async function abrir (n) {
      if (!n.leida) await store.dispatch('notificaciones/marcarLeida', n.id)
      if (n.ruta) {
        router.push(n.referenciaId ? { path: n.ruta, query: { id: n.referenciaId } } : { path: n.ruta })
      }
    }

    function marcarTodas () {
      store.dispatch('notificaciones/marcarTodasLeidas')
    }

    function colorNivel (nivel) {
      return { info: 'primary', warning: 'warning', error: 'error' }[nivel] || 'primary'
    }

    function iconoNivel (nivel) {
      return { info: 'mdi-information', warning: 'mdi-alert', error: 'mdi-alert-circle' }[nivel] || 'mdi-information'
    }

    function formatFecha (f) {
      return f ? new Date(f).toLocaleString('es-SV') : ''
    }

    onMounted(() => {
      store.dispatch('notificaciones/fetchUnreadCount')
      intervalId = setInterval(() => store.dispatch('notificaciones/fetchUnreadCount'), 60000)
    })

    onUnmounted(() => { if (intervalId) clearInterval(intervalId) })

    return { items, unreadCount, onToggle, abrir, marcarTodas, colorNivel, iconoNivel, formatFecha }
  }
}
</script>
